import {
    OFFERS_RESPONSE,
    USER_REQUEST,
    USER_RESPONSE,
    REGISTRATION_VERIFICATION_ERROR,
    CONTENT_REQUEST,
    CONTENT_RESPONSE,
    THEME_RESPONSE,
    PAGECONTENT_RESPONSE,
    SUPERCATEGORY_RESPONSE,
    STORE_RESPONSE,
    RETAILER_RESPONSE,
    TOURISM_RESPONSE,
    SELECT_FILTER_OPTION,
    SET_ACTIVE_RETAILER,
    SHOW_MORE_INFO,
    HIDE_MORE_INFO,
    SET_REDEEM_MODAL_OFFER,
    REMOVE_REDEEM_MODAL_OFFER,
    FINISHED_OFFER_REDEMPTION,
    SET_MODAL_REF,
    SET_FILTER_MENU_STATE,
    SET_FILTER_MENU_REF,
    STARTING_OFFER_REDEMPTION,
    FAILED_OFFER_REDEMPTION,
    USER_REDEMPTIONS,
    SET_REDEEMED_OFFER_REF,
    REMOVE_REDEEMED_OFFER_REF
} from './actions'

const initialState = {
    error: null,
    loading: true,
    content: null,
    pageContent: null,
    offers: null,
    stores: null,
    theme: null,
    user: null,
    retailers: null,
    tourismRetailers: null,
    selectedFilterCategory: null,
    filterMenuOpen: false,
    activeRetailerSlug: null,
    moreInfoOfferId: null,
    redeemModalOfferId: null,
    modalRef: null,
    filterMenuref: null,
    redeemErrorMessage: null,
    redeemedOfferRef: null
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case OFFERS_RESPONSE:
            return Object.assign({}, state, {
                offers: action.payload,
                loading: false
            })
        case USER_REQUEST:
            return Object.assign({}, state, {
                loading: true
            })
        case USER_RESPONSE:
            return Object.assign({}, state, {
                user: action.payload,
                loading: false
            })
        case REGISTRATION_VERIFICATION_ERROR:
            return Object.assign({}, state, {
                error: action.payload,
                loading: false
            })
        case USER_REDEMPTIONS:
            return {
                ...state,
                offers: state.offers.map(offer => {
                    return {
                        ...offer,
                        redeemed: action.payload.filter(redemption => {
                            return redemption.offerId === offer.id
                        }).length > 0
                    }
                })
            }
        case CONTENT_REQUEST:
            return Object.assign({}, state, {
                loading: true
            })
        case CONTENT_RESPONSE:
            return Object.assign({}, state, {
                content: action.payload
            })
        case THEME_RESPONSE:

            return {
                ...state,
                theme: {
                    ...state.theme,
                    ...action.payload,
                    colors: JSON.parse(action.payload.colors)
                }
            }
        case PAGECONTENT_RESPONSE:
            return Object.assign({}, state, {
                pageContent: action.payload
            })

        case SUPERCATEGORY_RESPONSE:
            const categories = action.payload.filter(category => {
                return category.content.component === 'super_category'
            }).map(superCategory => {
                return Object.assign({},
                    Object.assign({}, ...superCategory.content,
                        {
                            name: superCategory.content.title,
                            slug: superCategory.slug
                        }), {
                        subCategory: action.payload
                            .filter(category => {
                                return category.content.component === 'category' &&
                                    category.full_slug.startsWith(superCategory.full_slug)
                            })
                            .map(category => {
                                return {
                                    ...category,
                                    name: category.content.title,
                                    displayOrder: category.content.displayOrder
                                }
                            })
                    })
            })

            return Object.assign({}, state, {
                superCategories: categories
            })

        case STORE_RESPONSE:
            return {
                ...state,
                stores: action.payload.map(store => {
                    return {
                        ...store.content,
                        id: store.uuid
                    }
                })
            }

        case RETAILER_RESPONSE:
            return Object.assign({}, state, {
                retailers: action.payload.map((retailer) => {
                    return { ...retailer, id: retailer.uuid }
                })
            })

        case TOURISM_RESPONSE:
            return Object.assign({}, state, {
                tourismRetailers: (action.payload.map(retailer => {
                    return {
                        ...retailer,
                        name: retailer.content.retailer,
                        logo: retailer.content.offerImage,
                        stores: [{
                            offers: [{
                                ...retailer.content,
                                id: retailer.uuid
                            }]
                        }]
                    }
                })).sort((a, b) => a.content.retailer.toLowerCase().localeCompare(b.content.retailer.toLowerCase()))
            })

        case SET_FILTER_MENU_REF:
            return {
                ...state,
                filterMenuRef: action.payload
            }

        case SET_FILTER_MENU_STATE:
            return {
                ...state,
                filterMenuOpen: action.payload
            }

        case SELECT_FILTER_OPTION:
            return {
                ...state,
                filterMenuOpen: false,
                selectedFilterCategory: action.payload
            }

        case SET_ACTIVE_RETAILER:
            return {
                ...state,
                activeRetailerSlug: action.payload.slugs
            }

        case SHOW_MORE_INFO:
            return {
                ...state,
                moreInfoOfferId: action.payload.id
            }

        case HIDE_MORE_INFO:
            return {
                ...state,
                moreInfoOfferId: null
            }

        case SET_REDEEM_MODAL_OFFER:
            return {
                ...state,
                redeemModalOfferId: action.payload.id,
                redeemErrorMessage: null
            }

        case REMOVE_REDEEM_MODAL_OFFER:
            return {
                ...state,
                redeemModalOfferId: null
            }

        case STARTING_OFFER_REDEMPTION:
            return {
                ...state,
                loading: true,
            }

        case FINISHED_OFFER_REDEMPTION:
            return {
                ...state,
                redeemModalOfferId: null,
                moreInfoOfferId: null,
                loading: false,
                offers: state.offers.map(offer => {
                    return offer.id === action.payload.id ?
                        { ...offer, redeemed: true } :
                        offer
                })
            }

        case FAILED_OFFER_REDEMPTION:
            return {
                ...state,
                loading: false,
                redeemErrorMessage: action.payload.error,
                moreInfoOfferId: null,
                offers: state.offers.map(offer => {
                    return offer.id === action.payload.offer.id ?
                        { ...offer, redeemed: true } :
                        offer
                })
            }

        case SET_MODAL_REF:
            return {
                ...state,
                modalRef: action.payload
            }

        case SET_REDEEMED_OFFER_REF:
            return {
                ...state,
                redeemedOfferRef: action.payload
            }

        case REMOVE_REDEEMED_OFFER_REF:
            return {
                ...state,
                redeemedOfferRef: null
            }

        default:
            return state;
    }
}

export default reducer



// WEBPACK FOOTER //
// ./reducers.js